// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"dp-z","breadcrumbForward":"ep-z","breadcrumbBack":"fp-z","selected":"gp-z"};